(function () {
  var STATE_NAMES = {
    US: 'Federal',
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
    FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
    IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
    ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
    MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
    NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
    VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
  };

  var MAP_LAYOUT = [
    ['AK', null, null, null, null, null, null, null, null, null, 'ME'],
    [null, null, null, null, null, null, null, null, null, 'VT', 'NH'],
    ['WA', 'ID', 'MT', 'ND', 'MN', 'WI', 'IL', 'MI', null, 'NY', 'MA'],
    ['OR', 'NV', 'WY', 'SD', 'IA', 'IN', 'OH', 'PA', 'NJ', 'CT', 'RI'],
    ['CA', 'UT', 'CO', 'NE', 'MO', 'KY', 'WV', 'VA', 'MD', 'DE', null],
    [null, 'AZ', 'NM', 'KS', 'AR', 'TN', 'NC', 'SC', 'DC', null, null],
    [null, null, null, 'OK', 'LA', 'MS', 'AL', 'GA', null, null, null],
    ['HI', null, null, 'TX', null, null, null, 'FL', null, null, null]
  ];

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildRowElement(program) {
    var row = document.createElement('div');
    row.className = 'rebate-program-row';
    row.setAttribute('data-rebate-program', '');
    row.setAttribute('data-state', program.state_code);
    row.setAttribute('data-state-name', program.state_name || STATE_NAMES[program.state_code] || program.state_code);

    var rebateHtml = '<p class="rebate-program-row__rebate">' + escapeHtml(program.rebate_amount) + '</p>';

    var providerHtml = '<p class="rebate-program-row__provider">' + escapeHtml(program.provider) + '</p>';
    var linkH = '>'
    if(program.category.includes('Charger')){
      var linkH = 'href="https://ev-lectron.com/collections/level-2-ev-chargers">'
    }
    
    var programHtml = program.program_url
      ? '<a class="rebate-program-row__program rebate-program-row__program--link" href="' +
        escapeHtml(program.program_url) +
        '" target="_blank" rel="noopener noreferrer">' +
        escapeHtml(program.program_name) +
        '</a>'
      : '<p class="rebate-program-row__program">' + escapeHtml(program.program_name) + '</p>';

    var tagHtml = program.category
      ? '<a class="rebate-program-row__tag" '+ linkH + escapeHtml(program.category) + '</a>'
      : '';

    row.innerHTML =
      '<div class="rebate-program-row__provider-col">' +
      providerHtml +
      programHtml +
      tagHtml +
      '</div>' +
      '<div class="rebate-program-row__description-col">' +
      '<p class="rebate-program-row__description">' + escapeHtml(program.description) + '</p>' +
      '</div>' +
      '<div class="rebate-program-row__rebate-col">' +
      rebateHtml +
      '</div>';

    return row;
  }

  function collectPrograms() {
    var programs = [];
    var seen = new Set();

    document.querySelectorAll('[data-rebate-catalog-data]').forEach(function (script) {
      if (!script.textContent || !script.textContent.trim()) return;
      try {
        var chunk = JSON.parse(script.textContent);
        if (!Array.isArray(chunk)) return;
        chunk.forEach(function (program) {
          if (!program || !program.state_code) return;
          var key = [
            program.state_code,
            program.provider,
            program.program_name,
            program.program_url
          ].join('|');
          if (seen.has(key)) return;
          seen.add(key);
          programs.push({
            state_code: String(program.state_code).toUpperCase(),
            state_name: program.state_name || STATE_NAMES[program.state_code] || program.state_code,
            provider: program.provider || '',
            program_name: program.program_name || '',
            category: program.category || 'EV Chargers',
            description: program.description || '',
            rebate_amount: program.rebate_amount || '',
            program_url: program.program_url || ''
          });
        });
      } catch (error) {
        console.warn('Rebate finder: could not parse catalog JSON', error);
      }
    });

    return programs;
  }

  function initFinder(root) {
    if (!root) return;

    var tableBody = root.querySelector('[data-rpf-table-body]');
    var stateSelect = root.querySelector('[data-rpf-state-select]');
    var zipInput = root.querySelector('[data-rpf-zip-input]');
    var zipError = root.querySelector('[data-rpf-zip-error]');
    var zipErrorClose = root.querySelector('[data-rpf-zip-error-close]');
    var zipErrorDismissed = false;
    var summaryName = root.querySelector('[data-rpf-summary-name]');
    var summaryCount = root.querySelector('[data-rpf-summary-count]');
    var summaryMeta = root.querySelector('[data-rpf-summary-meta]');
    var headerName = root.querySelector('[data-rpf-header-name]');
    var headerMeta = root.querySelector('[data-rpf-header-meta]');
    var mapGrid = root.querySelector('[data-rpf-map]');
    var emptyState = root.querySelector('[data-rpf-empty]');
    var noDataState = root.querySelector('[data-rpf-no-data]');

    if (!tableBody || !stateSelect) return;

    var defaultState = (root.dataset.defaultState || 'CA').toUpperCase();
    var programs = collectPrograms();
    var allRows = programs.map(buildRowElement);
    var stateStats = {};
    var providersByState = {};

    programs.forEach(function (program) {
      var code = program.state_code;
      if (!stateStats[code]) {
        stateStats[code] = { programs: 0, providers: {}, name: program.state_name };
      }
      stateStats[code].programs += 1;
      if (program.provider) stateStats[code].providers[program.provider] = true;
    });

    Object.keys(stateStats).forEach(function (code) {
      providersByState[code] = Object.keys(stateStats[code].providers).length;
    });

    function buildMap() {
      if (!mapGrid) return;
      mapGrid.innerHTML = '';

      MAP_LAYOUT.forEach(function (row) {
        var rowEl = document.createElement('div');
        rowEl.className = 'rpf-map__row';

        row.forEach(function (code) {
          var cell = document.createElement('div');
          cell.className = 'rpf-map__cell';

          if (!code) {
            cell.classList.add('rpf-map__cell--empty');
            rowEl.appendChild(cell);
            return;
          }

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rpf-map__state';
          btn.setAttribute('data-rpf-map-state', code);
          btn.textContent = code;
          btn.setAttribute('aria-label', STATE_NAMES[code] || code);

          var count = stateStats[code] ? stateStats[code].programs : 0;
          if (count > 0) {
            btn.classList.add('rpf-map__state--has');
            btn.setAttribute('title', (STATE_NAMES[code] || code) + ' (' + count + ')');
          } else {
            btn.classList.add('rpf-map__state--none');
            btn.disabled = true;
          }

          cell.appendChild(btn);
          rowEl.appendChild(cell);
        });

        mapGrid.appendChild(rowEl);
      });
    }

    function populateStateSelect() {
      var codes = Object.keys(stateStats).sort(function (a, b) {
        var nameA = stateStats[a].name || STATE_NAMES[a] || a;
        var nameB = stateStats[b].name || STATE_NAMES[b] || b;
        return nameA.localeCompare(nameB);
      });

      stateSelect.innerHTML = '';

      if (!codes.length) {
        var emptyOpt = document.createElement('option');
        emptyOpt.value = '';
        emptyOpt.textContent = 'No programs loaded';
        stateSelect.appendChild(emptyOpt);
        stateSelect.disabled = true;
        return;
      }

      stateSelect.disabled = false;
      codes.forEach(function (code) {
        var opt = document.createElement('option');
        var label = stateStats[code].name || STATE_NAMES[code] || code;
        opt.value = code;
        opt.textContent = label + ' (' + stateStats[code].programs + ')';
        stateSelect.appendChild(opt);
      });
    }

    function getRowsForState(code) {
      return allRows.filter(function (row) {
        return row.getAttribute('data-state') === code.toUpperCase();
      });
    }

    function renderTable(code) {
      var rows = getRowsForState(code);
      tableBody.innerHTML = '';

      rows.forEach(function (row) {
        var clone = row.cloneNode(true);
        clone.classList.add('rebate-program-row--visible');
        tableBody.appendChild(clone);
      });

      if (emptyState) emptyState.hidden = rows.length > 0;
    }

    function updateSummary(code) {
      var stats = stateStats[code];
      var name = (stats && stats.name) || STATE_NAMES[code] || code;
      var programCount = stats ? stats.programs : 0;
      var providerCount = providersByState[code] || 0;
      var meta = programCount + ' programs \u2022 ' + providerCount + ' providers';

      if (summaryName) summaryName.textContent = name;
      if (summaryCount) summaryCount.textContent = String(programCount);
      if (summaryMeta) summaryMeta.textContent = meta;
      if (headerName) headerName.textContent = name;
      if (headerMeta) headerMeta.textContent = meta;
    }

    function setActiveState(code, options) {
      options = options || {};
      code = (code || '').toUpperCase();

      if (!stateStats[code]) {
        code = defaultState;
        if (!stateStats[code]) {
          var keys = Object.keys(stateStats);
          code = keys.length ? keys[0] : '';
        }
      }

      if (!code) {
        if (noDataState) noDataState.hidden = false;
        if (emptyState) emptyState.hidden = true;
        tableBody.innerHTML = '';
        return;
      }

      if (noDataState) noDataState.hidden = true;
      if (stateSelect.value !== code) stateSelect.value = code;

      root.querySelectorAll('[data-rpf-map-state]').forEach(function (btn) {
        var active = btn.getAttribute('data-rpf-map-state') === code;
        btn.classList.toggle('rpf-map__state--selected', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      renderTable(code);
      updateSummary(code);

      if (!options.skipUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('state', code);
        if (zipInput && zipInput.value.trim()) {
          url.searchParams.set('zip', zipInput.value.trim());
        } else {
          url.searchParams.delete('zip');
        }
        window.history.replaceState({}, '', url.toString());
      }
    }

    function normalizeZip(zip) {
      return (zip || '').replace(/\D/g, '').slice(0, 5);
    }

    function isValidUSZip(zip) {
      if (window.RebateZipValidity && window.RebateZipValidity.isValidUSZip) {
        return window.RebateZipValidity.isValidUSZip(zip);
      }
      return normalizeZip(zip).length === 5;
    }

    function showZipError(show) {
      if (!zipError) return;
      zipError.hidden = !show;
      if (zipInput) {
        zipInput.classList.toggle('rpf-input--error', show);
        zipInput.setAttribute('aria-invalid', show ? 'true' : 'false');
      }
    }

    function validateZipInput(options) {
      options = options || {};
      if (!zipInput) return;
      if (zipErrorDismissed && !options.force) return;

      var digits = normalizeZip(zipInput.value);

      if (!digits.length) {
        showZipError(false);
        return;
      }

      if (digits.length < 5) {
        showZipError(!!options.force);
        return;
      }

      if (!isValidUSZip(digits)) {
        showZipError(true);
        return;
      }

      var zipState = zipToState(digits);
      if (zipState && stateStats[zipState]) {
        showZipError(false);
        setActiveState(zipState);
        return;
      }

      showZipError(true);
    }

    function zipToState(zip) {
      zip = normalizeZip(zip);
      if (zip.length < 3) return null;
      var prefix = parseInt(zip.slice(0, 3), 10);
      if (prefix >= 350 && prefix <= 369) return 'AL';
      if (prefix >= 995 && prefix <= 999) return 'AK';
      if (prefix >= 850 && prefix <= 865) return 'AZ';
      if (prefix >= 716 && prefix <= 729) return 'AR';
      if (prefix >= 900 && prefix <= 966) return 'CA';
      if (prefix >= 800 && prefix <= 816) return 'CO';
      if (prefix >= 60 && prefix <= 69) return 'CT';
      if (prefix >= 197 && prefix <= 199) return 'DE';
      if (prefix >= 200 && prefix <= 205) return 'DC';
      if (prefix >= 320 && prefix <= 349) return 'FL';
      if (prefix >= 300 && prefix <= 319) return 'GA';
      if (prefix >= 967 && prefix <= 968) return 'HI';
      if (prefix >= 832 && prefix <= 838) return 'ID';
      if (prefix >= 600 && prefix <= 629) return 'IL';
      if (prefix >= 460 && prefix <= 479) return 'IN';
      if (prefix >= 500 && prefix <= 528) return 'IA';
      if (prefix >= 660 && prefix <= 679) return 'KS';
      if (prefix >= 400 && prefix <= 427) return 'KY';
      if (prefix >= 700 && prefix <= 714) return 'LA';
      if (prefix >= 39 && prefix <= 49) return 'ME';
      if (prefix >= 206 && prefix <= 219) return 'MD';
      if (prefix >= 10 && prefix <= 27) return 'MA';
      if (prefix >= 480 && prefix <= 499) return 'MI';
      if (prefix >= 550 && prefix <= 567) return 'MN';
      if (prefix >= 386 && prefix <= 397) return 'MS';
      if (prefix >= 630 && prefix <= 658) return 'MO';
      if (prefix >= 590 && prefix <= 599) return 'MT';
      if (prefix >= 680 && prefix <= 693) return 'NE';
      if (prefix >= 889 && prefix <= 898) return 'NV';
      if (prefix >= 30 && prefix <= 38) return 'NH';
      if (prefix >= 70 && prefix <= 89) return 'NJ';
      if (prefix >= 870 && prefix <= 884) return 'NM';
      if (prefix >= 100 && prefix <= 149) return 'NY';
      if (prefix >= 270 && prefix <= 289) return 'NC';
      if (prefix >= 580 && prefix <= 588) return 'ND';
      if (prefix >= 430 && prefix <= 459) return 'OH';
      if (prefix >= 730 && prefix <= 749) return 'OK';
      if (prefix >= 970 && prefix <= 979) return 'OR';
      if (prefix >= 150 && prefix <= 196) return 'PA';
      if (prefix >= 28 && prefix <= 29) return 'RI';
      if (prefix >= 290 && prefix <= 299) return 'SC';
      if (prefix >= 570 && prefix <= 577) return 'SD';
      if (prefix >= 370 && prefix <= 385) return 'TN';
      if (prefix >= 750 && prefix <= 799) return 'TX';
      if (prefix >= 840 && prefix <= 847) return 'UT';
      if (prefix >= 50 && prefix <= 59) return 'VT';
      if (prefix >= 220 && prefix <= 246) return 'VA';
      if (prefix >= 980 && prefix <= 994) return 'WA';
      if (prefix >= 247 && prefix <= 269) return 'WV';
      if (prefix >= 530 && prefix <= 549) return 'WI';
      if (prefix >= 820 && prefix <= 831) return 'WY';
      return null;
    }

    buildMap();
    populateStateSelect();

    if (noDataState) noDataState.hidden = programs.length > 0;

    var initialState = defaultState;
    var params = new URLSearchParams(window.location.search);
    if (params.get('state')) initialState = params.get('state').toUpperCase();
    if (params.get('zip') && zipInput) {
      zipInput.value = params.get('zip');
      var zipState = zipToState(params.get('zip'));
      if (zipState && stateStats[zipState]) initialState = zipState;
    }

    setActiveState(initialState, { skipUrl: true });
    validateZipInput();

    if (!root.dataset.rpfBound) {
      root.dataset.rpfBound = 'true';

      stateSelect.addEventListener('change', function () {
        setActiveState(stateSelect.value);
      });

      if (mapGrid) {
        mapGrid.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-rpf-map-state]');
          if (!btn || btn.disabled) return;
          setActiveState(btn.getAttribute('data-rpf-map-state'));
        });
      }

      if (zipInput) {
        var zipTimer;
        zipInput.addEventListener('input', function () {
          zipErrorDismissed = false;
          clearTimeout(zipTimer);
          zipTimer = setTimeout(function () {
            validateZipInput();
          }, 300);
        });

        zipInput.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          clearTimeout(zipTimer);
          zipErrorDismissed = false;
          validateZipInput({ force: true });
        });
      }

      if (zipErrorClose) {
        zipErrorClose.addEventListener('click', function () {
          zipErrorDismissed = true;
          showZipError(false);
        });
      }
    }

    root.dataset.rpfReady = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-rpf-finder]').forEach(function (finder) {
      finder.dataset.rpfReady = 'false';
      initFinder(finder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
